/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react'
// import { useState } from 'react'
import updateMoviePublished from '../../Services/Mutations/UpdateMoviePublished'
import { ToastStyle, allCrewPaths, crewArray } from '../Data/MovieStaticData'
import { Auth } from 'aws-amplify'
import { ToastContainer, toast } from 'react-toastify'
import getPostUpdateMovie from '../../Services/Mutations/GetpostupdateMovie'
import 'react-toastify/dist/ReactToastify.css'
import BulkActionsApply from './BulkActionsApply'
import Config from '../../Config/Config.json'
// import MainCellEntry from './MainCellEntry'
import MovieTable from './MovieTable'
import { DefinedPermissions } from '../Constants/Permissions'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import ActionsDiv from './ActionsDiv'
function BulkActions(props) {
  //
  const {
    checkSelectedArrayLength,
    handleActions,
    handleDelete,
    lodeMoreDisble,
    handleLoadMore,
    // counter,
    movieAndWebSeries,
    columns,
    // ListMoviesDataNew,
    handleAdd,
    handleChange,
    checkEmptyArray,
    setIsLoading,
    bulkActionName,
    checkBoxArr,
    ListMoviesDataItems,
    checkSelectedArray,
    setListMoviesDataItems,
    setCheckBoxArr,
    approveMovie,
    handleDeleteClick,
    checkboxfunction,
  } = props
  const [EditApproveOptionPermission, setEditApproveOptionPermission] = useState(false)
  const [DeleteApproveOptionPermission, setDeleteApproveOptionPermission] = useState(false)
  const [BulkActionApproveOptionPermission, setBulkActionApproveOptionPermission] = useState(false)
  const [moviePublishingApproveal, setMoviePublishingApproval] = useState(false)
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const ListMoviesDataNew =
    ListMoviesDataItems &&
    ListMoviesDataItems.map((item, index) => ({
      ...item,
      Sno: index + 1,
      movieDirectedBy_Te: item.movieDirectedBy,
      movieProducedBy_Te: item.movieProducedBy,
      movieCast_Te: item.movieCast,
      movieCinematography_Te: item.movieCinematography,
      movieEditedBy_Te: item.movieEditedBy,
      movieMusicBy_Te: item.movieMusicBy,
      movieDialogueBy_Te: item.movieDialogueBy,
      movieWrittenBy_Te: item.movieWrittenBy,
      movieScreenplayBy_Te: item.movieScreenplayBy,
      movieStoryBy_Te: item.movieStoryBy,
      // tags: item.tags,
      check: (
        <input
          type='checkbox'
          onChange={() => checkboxfunction({ id: item.SK, name: item.PK, sendTFIDBPN: item.sendTFIDBPN })}
          id={item.SK}
          name={item.PK}
          checked={Boolean(checkBoxArr.some(x => x.SK === item.SK))}
        />
      ),
      Action: (
        <ActionsDiv
          item={item}
          handleDeleteClick={handleDeleteClick}
          index={index}
          approveMovie={approveMovie}
          EditApproveOptionPermission={EditApproveOptionPermission}
          DeleteApproveOptionPermission={DeleteApproveOptionPermission}
          moviePublishingApproveal={moviePublishingApproveal}
          statusType={props.statusType}
        />
      ),
    }))

  const applyFunction = async () => {
    let statusType = ''
    let message = ''
    //
    if (bulkActionName === 'Delete') {
      const name = Config.Environment
      const test = `Deleting Data in ${name}`

      if (confirm(test) === true) {
        statusType = 'deleted'
        message = 'Content deleted Successfully'
      } else {
        statusType = 'noDelete'
      }
    }

    if (bulkActionName === 'Approve') {
      statusType = 'published'
      message = 'Content aproved Successfully'
    }

    if (bulkActionName === 'Draft') {
      statusType = 'draft'
      message = 'Content drafted Successfully'
    }

    setIsLoading(true)

    checkBoxArr.map(async item => {
      const publishedListUpdate = {
        status: statusType,
        PK: item.PK,
        SK: item.SK,
        ...(item.sendTFIDBPN && { sendTFIDBPN: item.sendTFIDBPN }),
        moderatorID: Auth.user.username,
        moderatorHandle: loggedInUserHandle,
      }
      const publishedMovies =
        statusType === 'noDelete' ? '' : await updateMoviePublished(publishedListUpdate)
      const remainingElements =
        ListMoviesDataItems &&
        ListMoviesDataItems.filter(elem => !checkSelectedArray.find(({ PK }) => elem.PK === PK))
      const { statusCode, statusMessage } = publishedMovies.data.updateMovieStatus
      if (statusCode === 'A367') {
        toast.success(message, ToastStyle)
        setListMoviesDataItems(remainingElements)
      } else if (statusCode === 'A371') {
        toast.success(statusMessage, ToastStyle)
        setListMoviesDataItems(remainingElements)
      }

      setCheckBoxArr(checkBoxArr)
      return publishedListUpdate
    })
    setIsLoading(false)
  }

  const updatedMovieData11 = async parameters => {
    setIsLoading(true)
    const { path, value, changedData, indexValue } = parameters

    // console.log(changedData.movieReleasedDateUI, '   updated_movie_data')
    const updatedMovieDataInput =
      path === 'movieCast' || path === 'movieCast_Te'
        ? {
            PK: changedData.PK,
            SK: changedData.SK,
            movieID: changedData.movieID,
            updateCrew: false,
            updateCast: true,
            updateCombinations: false,
            cast: value,
            contentType: movieAndWebSeries,
            moderatorID: Auth.user.username,
            moderatorHandle: loggedInUserHandle,
          }
        : crewArray.some(item => item === path)
        ? {
            PK: changedData.PK,
            SK: changedData.SK,
            movieID: changedData.movieID,
            updateCrew: true,
            updateCast: false,
            updateCombinations: false,
            crew: value.filteredArray,
            contentType: movieAndWebSeries,
            moderatorID: Auth.user.username,
            moderatorHandle: loggedInUserHandle,
          }
        : {
            [path]: value,
            PK: changedData.PK,
            SK: changedData.SK,
            contentType: movieAndWebSeries,
            movieID: changedData.movieID,
            movieReleasedDate: Number(changedData.movieReleasedDateUI),
            moderatorID: Auth.user.username,
            moderatorHandle: loggedInUserHandle,
          }
    // console.log(updatedMovieDataInput, 'updatedMovieDataInput11')
    const response = await getPostUpdateMovie(updatedMovieDataInput)
    // console.log(response, '==========response======')
    const statuscode = response.statusCode
    // console.log(response.statusCode, 'A001')
    if (statuscode === 'A001') {
      toast.success(
        `${movieAndWebSeries === 'movies' ? 'movie' : movieAndWebSeries} updated Successfully`,
        ToastStyle,
      )
      // console.log(path, 'pathpathpath12312')
      if (allCrewPaths.some(item => item === path)) {
        // console.log(value.pathArrayValues, 'value.pathArrayValues12121')

        props.updateData(indexValue, path, value.pathArrayValues)
      } else {
        // console.log(value.filteredArray, 'value.filteredArray12121')
        props.updateData(indexValue, path, value)
      }
    } else {
      toast.error('Failed To Update Movie', ToastStyle)
    }

    setIsLoading(false)
  }

  useEffect(() => {
    const getPermissions = async () => {
      const permissionInput = {
        mobileNumber: Auth.user.attributes.phone_number,
      }
      const userPermissions = await GetUserPermissions(permissionInput)
      console.log(userPermissions, 'userPermissions')
      const permissions = []
      const permissionsArr = []
      if (userPermissions && userPermissions.userRolesAndPermissions) {
        userPermissions.userRolesAndPermissions.map(item => {
          permissions.push(...item.permissions)
          return item
        })
        permissions.map(permission => {
          permissionsArr.push(permission.name)
          return permission
        })
      }

      const EDitUserApprovePermission = permissionsArr.includes(DefinedPermissions.AllMoviesEdit)
      const DeleteUserApprovePermission = permissionsArr.includes(
        DefinedPermissions.AllMoviesDelete,
      )
      const BulkActionUserApprovePermission = permissionsArr.includes(
        DefinedPermissions.AllMoviesBulkAction,
      )
      const moviePublishingUserApprovePermission = permissionsArr.includes(
        DefinedPermissions.DisplayApproveMovieOption,
      )
      setEditApproveOptionPermission(EDitUserApprovePermission)
      setDeleteApproveOptionPermission(DeleteUserApprovePermission)
      setBulkActionApproveOptionPermission(BulkActionUserApprovePermission)
      setMoviePublishingApproval(moviePublishingUserApprovePermission)
    }

    getPermissions()
  }, [])
  // function Row({ mode, columns, data, onChange, rowIndex }) {
  //   const [pathValue, setPathValue] = useState()
  //   return (
  //     <>
  //       <tr>
  //         {columns.map(({ path }, index, columnIndex) => {
  //           const handleChange = (value, indexValue) => {
  //             if (onChange) {
  //               const changedData = { ...data, [path]: value }
  //               setPathValue({ [path]: value })
  //               onChange(columnIndex, changedData)
  //               const params = {
  //                 path,
  //                 value,
  //                 changedData,
  //                 indexValue,
  //               }
  //               updatedMovieData11(params)
  //             }
  //           }

  //           return (
  //             <>
  //               <MainCellEntry
  //                 // movieAndWebSeries={props.movieAndWebSeries}
  //                 rolename={props.rolename}
  //                 personIdval={props.personIdval}
  //                 setLocalMode={props.setLocalMode}
  //                 localMode={props.localMode}
  //                 setpersonIdval={props.setpersonIdval}
  //                 setRolename={props.setRolename}
  //                 columns={columns}
  //                 path={path}
  //                 mode={mode}
  //                 data={data}
  //                 pathValue={pathValue}
  //                 handleChange={handleChange}
  //                 rowIndex={rowIndex}
  //               />
  //             </>
  //           )
  //         })}
  //       </tr>
  //       <ToastContainer
  //         position='top-right'
  //         autoClose={5000}
  //         hideProgressBar={false}
  //         newestOnTop={false}
  //         rtl={false}
  //       />
  //     </>
  //   )
  // }

  // function Table({ columns, data, onChange, onDelete }) {
  //   const [addedIndex, setAddedIndex] = useState()
  //   return (
  //     <div>
  //       <div style={{ float: 'right' }}>
  //         <br />
  //       </div>
  //       <table className='tableclassName mt-2'>
  //         <tbody>
  //           <tr
  //             className='red '
  //             style={{
  //               zIndex: '6',
  //               position: 'sticky',
  //               top: '0',
  //             }}
  //           >
  //             {columns.map(({ path, name }) => (
  //               <th
  //                 key={path}
  //                 className='tdclassName'
  //                 style={{ background: '#eee', border: '1px solid rgb(224, 224, 224)' }}
  //               >
  //                 {name}
  //               </th>
  //             ))}
  //           </tr>
  //           {data &&
  //             data.map((rowData, rowIndex) => {
  //               const handleChange = (columnIndex, changedData) => {
  //                 onChange?.(rowIndex, columnIndex, changedData)
  //               }

  //               const handleDelete = () => {
  //                 if (rowIndex !== addedIndex) {
  //                   setAddedIndex(addedIndex - 1)
  //                 }

  //                 onDelete?.(rowIndex, rowData)
  //               }

  //               return (
  //                 <Row
  //                   rowIndex={rowIndex}
  //                   key={rowData[rowIndex]}
  //                   mode={addedIndex === rowIndex ? 'edit' : 'read'}
  //                   columns={columns}
  //                   data={rowData}
  //                   onChange={handleChange}
  //                   onDelete={handleDelete}
  //                 />
  //               )
  //             })}
  //         </tbody>
  //       </table>
  //       <br />
  //     </div>
  //   )
  // }

  return (
    <div>
      <div>
        {BulkActionApproveOptionPermission && (
          <BulkActionsApply
            checkSelectedArrayLength={checkSelectedArrayLength}
            handleActions={handleActions}
            applyFunction={applyFunction}
          />
        )}
        {checkEmptyArray ? (
          <p>No data found</p>
        ) : (
          <MovieTable
            cellpadding='0'
            cellspacing='0'
            border='0'
            // id={counter}
            columns={columns}
            data={ListMoviesDataNew}
            onAdd={handleAdd}
            onChange={handleChange}
            onDelete={handleDelete}
            updatedMovieData11={updatedMovieData11}
            rolename={props.rolename}
            personIdval={props.personIdval}
            setLocalMode={props.setLocalMode}
            localMode={props.localMode}
            setpersonIdval={props.setpersonIdval}
            setRolename={props.setRolename}
          />
        )}
        {lodeMoreDisble ? (
          ''
        ) : (
          <button className='btn btn-primary' onClick={() => handleLoadMore()}>
            Load more...
          </button>
        )}
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </div>
  )
}

export default BulkActions
